export const keys = {
  contentTypes: {
    article: 'article',
    compexPage: 'compexPage',
    contributor: 'contributor',
    documentation: 'documentation',
    downloads: 'downloads',
    embed: 'embed',
    formConfig: 'formConfig',
    fund: 'fund',
    globalSettings: 'globalSettings',
    flexibleContent: 'flexibleContent',
    flexiblePage: 'flexiblePage',
    flexibleAccountPage: 'flexibleAccountPage',
    imageWrapper: 'imageWrapper',
    longformContent: 'longformContent',
    navigation: 'navigation',
    partnerCoBranding: 'partnerCoBranding',
    sacFilter: 'sacFilter',
    siteConfig: 'siteConfig',
  },
  siteConfig: {
    childBioPage: 'childBioPage',
    homePage: 'homePage',
    missingChildPage: 'missingChildPage',
    missingPage: 'missingPage',
    sacListPage: 'sacListPage',
  },
  dialogType: {
    componentDisplay: 'componentDisplay',
    focalPoint: 'focalPoint',
    iconPicker: 'iconPicker',
    logoPicker: 'logoPicker',
    supportedMergeFields: 'supportedMergeFields',
  },
  flexibleAssembly: {
    referenceTracker: 'referencedContent',
  },
  items: {
    referenceTracker: 'items',
  },
  linkField: {
    referenceTracker: 'linkedContent',
  },
  campaignFields: {
    attribution: 'attribution',
  },
  redirectFields: {
    legacyRedirectFrom: 'legacyRedirectFrom',
  },
  seoFields: {
    adminTitle: 'adminTitle',
    languagesToPublish: 'languagesToPublish',
    noIndexSeo: 'noIndexSeo',
    noIndexSite: 'noIndexSite',
    pageTitle: 'pageTitle',
    parentPage: 'parentPage',
    path: 'path',
    seoAnalysis: 'seoAnalysis',
    seoKeywords: 'seoKeywords',
    seoKeyphrase: 'seoKeyphrase',
    seoMetaDescription: 'seoMetaDescription',
    seoPreview: 'seoPreview',
    seoTitle: 'seoTitle',
    shareDescription: 'shareDescription',
    shareImage: 'shareImage',
    shareTitle: 'shareTitle',
    slug: 'slug',
  },
  articleFields: {
    publishDate: 'publishDate',
    primaryMedia: 'primaryMedia',
    intro: 'intro',
    conclusion: 'conclusion',
    contributors: 'contributors',
    primaryCta: 'primaryCta',
    secondaryCta: 'secondaryCta',
    faq: 'faq',
  },
  sacFields: {
    relatedContent: 'relatedContent',
    limit: 'limit',
    ageMax: 'ageMax',
    ageMin: 'ageMin',
    birthDate: 'birthDate',
    centerId: 'centerId',
    countries: 'countries',
    gender: 'gender',
    disability: 'disability',
    highlyVulnerable: 'highlyVulnerable',
    hiv: 'hiv',
    longestWaiting: 'longestWaiting',
    orphan: 'orphan',
  },
  fundFields: {
    fundTitle: 'fundTitle',
    fundId: 'fundId',
    tcmId: 'tcmId',
    fundCodeOneTime: 'fundCodeOneTime',
    fundCodeCommitment: 'fundCodeCommitment',
    interventionId: 'interventionId',
    minOneTimeAmount: 'minOneTimeAmount',
    icon: 'icon',
    donationLimitTotal: 'donationLimitTotal',
    availableFrequencies: 'availableFrequencies',
  },
  embedFields: {
    embedSettings: 'embedSettings',
  },
  contributorFields: {
    article: 'article',
    name: 'name',
    position: 'position',
    image: 'image',
  },
  partnerCoBrandingFields: {
    additionalAssociatedSourceCodes: 'additionalAssociatedSourceCodes',
    sourceCode: 'sourceCode',
    shortDescription: 'shortDescription',
  },
  customFields: {
    badge: 'badge',
    displayDate: 'displayDate',
    displayVariant: 'displayVariant',
    flexibleContent: 'flexibleContent',
    fund: 'fund',
    icon: 'icon',
    imageFocalPoint: 'imageFocalPoint',
    items: 'items',
    link: 'link',
    pageHierarchy: 'pageHierarchy',
    parentPage: 'parentPage',
    primaryCTA: 'primaryCTA',
    quotation: 'quotation',
    logo: 'logo',
    body: 'body',
    secondaryCTA: 'secondaryCTA',
    seoAnalysis: 'seoAnalysis',
    template: 'template',
    templateContent: 'templateContent',
    tertiaryCTA: 'tertiaryCTA',
    video: 'video',
    slug: 'slug',
    subNav: 'subNav',
    contentPosition: 'contentPosition',
    hierarchyStyle: 'hierarchyStyle',
    cta: 'cta',
  },
  taxonomies: {
    articleTheme: 'taxonomyArticleTheme',
    articleTopic: 'taxonomyTopic',
    articleType: 'taxonomyArticleType',
    cmsOrganization: 'taxonomyCmsOrganization',
    contentOwner: 'taxonomyContentOwner',
    fundCategory: 'taxonomyFundCategory',
    fundPromotion: 'taxonomyFundPromotion',
    funnel: 'taxonomyFunnel',
    other: 'taxonomyOther',
    personalizationSegment: 'taxonomyPersonalizationSegment',
    programCountry: 'taxonomyProgramCountry',
    programRegion: 'taxonomyProgramRegion',
  },
  groups: {
    content: 'content',
    extra: 'extra',
    filters: 'filters',
    links: 'links',
    seo: 'seo',
    taxonomy: 'taxonomy',
  },
  templates: {
    bio: 'bio',
    country: 'country',
    donate: 'donate',
    giftCatalog: 'giftCatalog',
    partner: 'partner',
  },
  articleTypes: {
    blogPost: 'blogPost',
    crisisUpdate: 'crisisUpdate',
    pressRelease: 'pressRelease',
  },
  accountComponents: {
    default: 'myCompassion',
    accountSettings: 'accountSettings',
    commitments: 'commitments',
    giftGiving: 'giftGiving',
    givingHistory: 'givingHistory',
    paymentSettings: 'paymentSettings',
    sectionHeading: 'sectionHeading',
    sponsorships: 'sponsorships',
    taxReceipts: 'taxReceipts',
  } as const,
  advancedComponents: {
    default: 'default',
    childBio: 'childBio',
    articleList: 'articleList',
    giftCatalog: 'giftCatalog',
    form: 'form',
    formDynamic: 'formDynamic',
    reviews: 'reviews',
    alert: 'alert',
  } as const,
};

export const editorLabels = {
  [keys.contentTypes.flexibleContent]: 'Content Block',
  [keys.contentTypes.formConfig]: 'Form Config Block',
  [keys.contentTypes.longformContent]: 'Longform Content Block',
  [keys.contentTypes.sacFilter]: 'SAC Block',
  [keys.contentTypes.navigation]: 'Navigation',
  [keys.contentTypes.embed]: 'Embed',
  [keys.contentTypes.flexiblePage]: 'Page',
  [keys.contentTypes.imageWrapper]: 'Media',
  [keys.contentTypes.contributor]: 'Contributor',
  [keys.contentTypes.article]: 'Article',
  [keys.contentTypes.documentation]: 'Documentation',
  [keys.contentTypes.siteConfig]: 'Site Config',
  [keys.contentTypes.compexPage]: 'Compex Page',
  [keys.contentTypes.partnerCoBranding]: 'Partner Co-Branding',
  [keys.contentTypes.flexibleAccountPage]: 'My Compassion Page',
  [keys.accountComponents.default]: 'My Component',
};

/**
 * Keys for content types that represent pages (have a slug).
 */
export const pageTypes = [
  keys.contentTypes.flexiblePage,
  keys.contentTypes.compexPage,
  keys.contentTypes.article,
  keys.contentTypes.downloads,
  keys.contentTypes.flexibleAccountPage,
  // todo: enable rich text and graphql to support this
  // keys.contentTypes.partnerCoBranding,
];

export const downloadTypes = [keys.contentTypes.downloads];

export const pageTemplates = [
  keys.templates.bio,
  keys.templates.country,
  keys.templates.donate,
  keys.templates.giftCatalog,
];

export const assemblyContentTypes = [
  keys.contentTypes.flexiblePage,
  keys.contentTypes.compexPage,
  keys.contentTypes.flexibleAccountPage,
];

export const assemblyTypes = [
  keys.contentTypes.flexibleContent,
  keys.contentTypes.formConfig,
  keys.contentTypes.longformContent,
  keys.contentTypes.navigation,
  keys.contentTypes.sacFilter,
  keys.contentTypes.embed,
];

export const assemblyTypesMy = [
  ...assemblyTypes,
  keys.accountComponents.default,
];

type AssemblyContentType = (typeof assemblyContentTypes)[number];
export const assemblyTypesByPage: Record<AssemblyContentType, string[]> = {
  [keys.contentTypes.flexiblePage]: assemblyTypes,
  [keys.contentTypes.compexPage]: assemblyTypes,
  [keys.contentTypes.flexibleAccountPage]: assemblyTypesMy,
};

export const linkFields = [
  keys.customFields.link,
  keys.customFields.primaryCTA,
  keys.customFields.secondaryCTA,
  keys.customFields.tertiaryCTA,
];

export const widgetIds = {
  ourApp: '##REPLACE_CONTENTFUL_EDITOR_APP_ID##',
  jsonApp: '3fLf4DnjbkN1yUA2V2fMgE',
  tenovosApp: '52xxRVqM0ULubth8NKJCY9',
  repeaterApp: '7ek22esW2z9i1kdmevLJXd',
};

export const notFoundPages = {
  '404-gotten': keys.siteConfig.missingChildPage,
  '404': keys.siteConfig.missingPage,
} as const;

export type NotFoundKey = keyof typeof notFoundPages;

export const disabledOnPublishFields = [
  keys.taxonomies.articleType,
  keys.seoFields.slug,
  keys.customFields.parentPage,
];
